import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { logError } from "@/lib/log";

const BookmarksContext = createContext(null);

export function BookmarksProvider({ children }) {
  const { user } = useAuth();
  const [bookmarks, setBookmarks] = useState([]);
  const [attorneys, setAttorneys] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setBookmarks([]); setAttorneys([]); return; }
    try {
      const { data } = await api.get("/me/bookmarks");
      setBookmarks(data.bookmarks);
      setAttorneys(data.attorneys);
    } catch (e) {
      logError("Failed to load bookmarks", e);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isSaved = useCallback((type, itemId) => bookmarks.some((b) => b.type === type && b.item_id === itemId), [bookmarks]);

  const toggle = useCallback(async (type, itemId) => {
    try {
      const { data } = await api.post("/me/bookmarks", { type, item_id: itemId });
      toast.success(data.saved ? "Saved to your dashboard" : "Removed from saved");
      await refresh();
      return data.saved;
    } catch (e) {
      logError("Failed to toggle bookmark", e);
      toast.error("Could not update saved items.");
    }
  }, [refresh]);

  return (
    <BookmarksContext.Provider value={{ bookmarks, attorneys, isSaved, toggle, refresh }}>
      {children}
    </BookmarksContext.Provider>
  );
}

export const useBookmarks = () => useContext(BookmarksContext);
